import { Flex, Result } from 'antd';
import React from 'react';

const NotFound = ({ details }) => {
  const {
    status = '404',
    title = 'Not Found!',
    subTitle = 'Sorry, the page you visited does not exist.',
  } = details || {};

  return (
    <Flex align="center" justify="center" style={{ height: '100%' }}>
      <Result status={status} title={title} subTitle={subTitle} />
    </Flex>
  );
};

export default NotFound;
